/**
 * Số thông báo chưa đọc của người dùng (GET /notifications/unread-count) — sổ ở CẤP
 * ỨNG DỤNG như `cong-viec-nen.ts`: chuông đầu trang, mục menu "Thông báo" và trang
 * Thông báo cùng đọc một giá trị; trang Thông báo gọi `napLaiSoChuaDoc()` ngay sau
 * khi đánh dấu đọc để huy hiệu khớp tức thì, không phải chờ chu kỳ thăm dò.
 *
 * Thăm dò 30 giây một lần, DỪNG khi tab trình duyệt bị ẩn (`document.hidden`) và
 * nạp lại ngay khi tab hiện trở lại. Lỗi mạng bỏ qua im lặng: giữ số cũ.
 */
import { useEffect, useState } from 'react';
import { thongBaoApi } from '../api/thong-bao-api';

export const CHU_KY_THAM_DO_MS = 30_000;

let soChuaDoc = 0;
const nguoiNghe = new Set<() => void>();
/** Nguồn số chưa đọc — ghi đè được trong kiểm thử. */
let nguon: () => Promise<{ soChuaDoc: number }> = () => thongBaoApi.soChuaDoc();

function bao(): void {
  nguoiNghe.forEach((f) => f());
}

export function laySoChuaDoc(): number {
  return soChuaDoc;
}

export function datSoChuaDoc(so: number): void {
  const moi = Number.isFinite(so) && so > 0 ? Math.floor(so) : 0;
  if (moi === soChuaDoc) return;
  soChuaDoc = moi;
  bao();
}

/** Chỉ dùng trong kiểm thử: thay nguồn số chưa đọc; không truyền = về mặc định. */
export function datNguonSoChuaDoc(f?: () => Promise<{ soChuaDoc: number }>): void {
  nguon = f ?? (() => thongBaoApi.soChuaDoc());
}

export async function napLaiSoChuaDoc(): Promise<void> {
  try {
    const kq = await nguon();
    datSoChuaDoc(Number(kq?.soChuaDoc ?? 0));
  } catch {
    /* mất mạng hoặc phiên hết hạn: giữ số cũ, lần thăm dò sau thử lại */
  }
}

/** Hook đọc số chưa đọc, vẽ lại khi số đổi. */
export function dungSoChuaDoc(): number {
  const [, ep] = useState(0);
  useEffect(() => {
    const f = (): void => ep((n) => n + 1);
    nguoiNghe.add(f);
    return () => {
      nguoiNghe.delete(f);
    };
  }, []);
  return soChuaDoc;
}

/**
 * Bật thăm dò định kỳ khi `bat` đúng (đã đăng nhập). Chỉ MỘT nơi gọi hook này
 * (`KhungTrang`); nơi khác đọc bằng `dungSoChuaDoc()`.
 */
export function dungThamDoSoChuaDoc(bat: boolean, chuKyMs = CHU_KY_THAM_DO_MS): void {
  useEffect(() => {
    if (!bat) return undefined;
    let h: ReturnType<typeof setInterval> | null = null;
    const dung = (): void => {
      if (h !== null) clearInterval(h);
      h = null;
    };
    const chay = (): void => {
      if (h !== null) return;
      void napLaiSoChuaDoc();
      h = setInterval(() => {
        if (!document.hidden) void napLaiSoChuaDoc();
      }, chuKyMs);
    };
    const doi = (): void => (document.hidden ? dung() : chay());
    if (!document.hidden) chay();
    document.addEventListener('visibilitychange', doi);
    return () => {
      dung();
      document.removeEventListener('visibilitychange', doi);
      // Đăng xuất / đổi người dùng: không để số của phiên trước còn lại.
      datSoChuaDoc(0);
    };
  }, [bat, chuKyMs]);
}
